const storeNativeLogInInLocalStorage = (nativeLogIn) => {
  localStorage.setItem('anova_native_log_in', true)
}

export default storeNativeLogInInLocalStorage
